import type { IWindowService } from "angular";
import { module } from "angular";
import type { IServiceWorkerService } from "./IServiceWorkerService";

export class ServiceWorkerService implements IServiceWorkerService {
    public static $inject: string[] = ["$window"];

    constructor(private readonly $window: IWindowService) {}

    public checkSupport() {
        return "serviceWorker" in this.$window.navigator;
    }

    public register(worker: string) {
        if (this.checkSupport()) {
            // eslint-disable-next-line
            this.$window.navigator.serviceWorker.register(worker);
        }
    }
}

module("mmServices").service("irServiceWorker", ServiceWorkerService);
